import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable,of } from 'rxjs';
import { ModalLoginComponent } from './modal-login/modal-login.component';
import { MatSnackBar } from "@angular/material/snack-bar";
import { CookieService } from 'ngx-cookie-service';

export interface credentials {
  username: string;
  password: string;
  message: string;
  validation: (cred: credentials) => Observable<any>
}

export interface HttpCall {
  url: string,
  method?: string,
  params?: any,
  headers?: HttpHeaders,
  body?: any,
  silent?: boolean
}

const urlBase:string = "/GTApi/"

@Injectable({
  providedIn: 'root'
})
export class HttpService {


  handle: (observer, call: HttpCall) => void
  getErrorText: (error: any) => string
  notify: (error: any) => void
  login: (cred: credentials) => void

  constructor(private http: HttpClient, private dialog: MatDialog, private snack: MatSnackBar, private coookies: CookieService) {

    var getErrorText = (error: any) => {
      var strError: string;
      if (error.message) {
        strError = error.message
      } else {
        if (error.data) {
          if (error.data.ExceptionMessage) {
            strError = error.data.ExceptionMessage
          } else {
            if (error.data.Message) {
              strError = error.data.Message + (error.data.MessageDetail ? '\n' + error.data.MessageDetail : '')
            } else {
              strError = error.data
            }
          }
        }
        if (error.statusText) {
          strError = (strError ? '\n' : '') + error.statusText
        }
      }
      if (!strError) strError = error;
      return strError
    }

    var notify = (error: any) => {
      var strError = getErrorText(error);
      if (strError && strError.trim()) snack.open(strError, "OK");
    }

    var validation = (cred: credentials): Observable<any> =>  {
      return new Observable<any>((observer) => {
        login(cred).subscribe({
          next(response) {
            observer.next(response);
            observer.complete();
          },
          error(response) {
            observer.error(getErrorText(response));
          }
        });
      });
    }

    var login = (cred: credentials) => {

      //return of("");

      let call: HttpCall = { url: "login/performLogin", body: cred }

      return new Observable<string>((observer) => {
        this.PostJSONContent(call).subscribe(
          (response: HttpResponse<any>) => {
            if (!response.body) {
              this.coookies.set("identityUID", response.headers.get("cf_uid"))
              this.coookies.set("identityS",  response.headers.get("cf_c"))
              observer.next("");
            } else {
              observer.error(response.body);
            }
            observer.complete();
          }
        );
      });
    }


    var handle = (observer, call: HttpCall) => {

      call.method = call.method ? call.method : "get"
      call.silent = !!call.silent
      call.method = call.method.toLowerCase();

      http.request(call.method, call.url, { body: call.body, params: call.params, responseType: "json", headers: call.headers, observe: "response", reportProgress: false })
        .subscribe({
          next(data) { data.headers.keys(); observer.next(data); observer.complete(); },
          error(error) {
            if ((error.status == 401 || error.status == 403) && !call.silent) {

              let data = {
                message: error.status == 403 ? 'Login scaduta' : '',
                validation: validation
              }

              const dialogRef = dialog.open(ModalLoginComponent, { closeOnNavigation: true, disableClose: true, data: data });
              dialogRef.afterClosed().subscribe(result => {
                //call.url="http://quotes.rest/qod.json";
                handle(observer, call);
              })
            } else {
              if (!call.silent) notify(error);
              observer.error(error);
            }
          }
        });
    }


    this.handle = handle;
    this.notify = notify;
    this.getErrorText = getErrorText;
    this.login = login;
  }



  public PostJSONContent<T>(call: HttpCall): Observable<T> {
    return new Observable<T>((observer) => {
      call.method = "post";
      call.url = urlBase + call.url;
      this.handle(observer, call)
    });
  }


  public GetJSONContent<T>(call: HttpCall): Observable<T> {
    return new Observable<T>((observer) => {
      call.method = "get";
      call.url = urlBase + call.url;
      this.handle(observer, call)
    });
  }

  public getUrl(base:string, obj:any=null){
    let url:string = urlBase + base;
    if(obj!=null){
      let p:HttpParams = new HttpParams();
      Object.keys(obj).forEach((k)=>{
        if(obj[k]) p=p.set(k, obj[k].toISOString ? obj[k].toISOString() : obj[k]);
      })
      if(p.keys().length) url += '?' + p.toString();
    }
    return url;
  }

  public logout() {

    let call: HttpCall = { url: "login/logoff" }

    return new Observable<string>((observer) => {
      this.GetJSONContent(call).subscribe(
        (response: HttpResponse<any>) => {
          if (!response.body) {
            this.coookies.delete("identityUID")
            this.coookies.delete("identityS")
            observer.next("");
          } else {
            observer.error(response.body);
          }
          observer.complete();
        }
      );
    });
  }

}
